import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
export const sortProductLines = productLines => {
  const copy = [...productLines];
  copy.sort((a, b) => {
    return AllProductLines.indexOf(a) - AllProductLines.indexOf(b);
  });
  return copy;
};
export const sortApiNamesByProductLevel = apiNames => {
  const copy = [...apiNames];
  copy.sort((a, b) => {
    return currentOrderedProductLevels.indexOf(getProductLevelFromApiNameString(a)) - currentOrderedProductLevels.indexOf(getProductLevelFromApiNameString(b));
  });
  return copy;
};